import { Helmet } from "react-helmet";

const BASE_TITLE = "All Ears";

interface AllEarsTitleProps {
  title?: string;
}

const AllEarsTitle: React.FC<AllEarsTitleProps> = ({ title }) => {
  return <Helmet title={title ? `${title} — ${BASE_TITLE}` : BASE_TITLE} />;
};

export default AllEarsTitle;
